/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { registerAdmin } from "../api/authApi";
import { loginSuccess } from "../redux/authSlice";
import LogoName from "../assets/images/logo_name.png";

const Register = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    department: ""
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const data = await registerAdmin(form);
      if (data.success) {
        setSuccess("Registration successful! Redirecting to dashboard...");
        // auto login after register
        dispatch(loginSuccess({ token: data.token, admin: data.admin }));
        setTimeout(() => {
          window.location.href = "/";
        }, 1500);
      } else {
        setError(data.message || "Registration failed, try again.");
      }
    } catch (err) {
      setError("Server error, please try later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
  {/* 🔥 Logo */}
      <div className="logo">
        <img src={LogoName} alt="Moovuruli Logo" />
      </div>
      <h2>Admin Register</h2>
      <form onSubmit={handleRegister}>
        <input
          type="text"
          name="name"
          placeholder="Enter Name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Enter Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Enter Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="department"
          placeholder="Enter Department"
          value={form.department}
          onChange={handleChange}
          required
        />
        {error && <p className="error-text">{error}</p>}
        {success && <p className="success-text">{success}</p>}
        {/* <button type="submit" disabled={loading}>
          {loading ? "Registering..." : "Register"}
        </button> */}
      </form>
      <p>
        Already have an account? <a href="/login">Login here</a>
      </p>
    </div>
  );
};

export default Register;
